











































import { Vue, Component, Watch } from "vue-property-decorator"
import { RouteConfig } from "vue-router"
import { mapGetters } from "vuex"
import SideBarItem from "../sidebarItem/index.vue"
import MenuItem from "../sidebarItem/item"
import AppLink from "../sidebarItem/link.vue"
@Component({
    components: {
        "sidebar-item": SideBarItem,
        "menu-item": MenuItem,
        "app-link": AppLink
    },
    computed: {
        ...mapGetters(["permissionRoutes", "isCollapse"])
    }
})
export default class Sidebar extends Vue {
    readonly permissionRoutes: any[]
    readonly isCollapse!: boolean
    selectedKeys: string[] = []
    openKeys: string[] = []
    cachedOpenKeys: string[] = []

    get rootSubmenuKeys() {
        const keys: string[] = []
        this.permissionRoutes.map(route => keys.push(route.path))
        return keys
    }

    updateMenu() {
        const routes = this.$route.matched.concat()
        const { hidden } = this.$route as any
        if (routes.length >= 3 && hidden) {
            routes.pop()
            const route = routes[routes.length - 1]
            this.selectedKeys = [route.path]
        } else {
            const route = routes.pop()
            this.selectedKeys = [route.path]
        }
        const openKeys: string[] = []
        routes.forEach(item => {
            const path = item.path
            path && openKeys.push(path as string)
        })
        this.isCollapse ? (this.cachedOpenKeys = openKeys) : (this.openKeys = openKeys)
    }
    @Watch("$route")
    routeChange() {
        this.updateMenu()
    }
    @Watch("isCollapse")
    collapesChange(val: boolean) {
        if (val) {
            this.cachedOpenKeys = this.openKeys.concat()
            this.openKeys = []
        } else {
            this.openKeys = this.cachedOpenKeys
        }
    }
    visible = false
    showDrawer() {
        this.visible = true
    }

    onClose() {
        this.visible = false
    }
    // TODO makeMenuNarrow 绑定在最外层
    makeMenuNarrow() {
        this.visible = false
    }

    jumpPage(parentPath: any, item: any) {
        const path = `${parentPath}/${item.path}`
        this.visible = false
        this.$router.push(path)
    }

    handleOpenChange(openKeys: string[]) {
        const latestOpenKey = openKeys.find(key => !this.openKeys.includes(key))
        if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
            this.openKeys = openKeys
        } else {
            this.openKeys = latestOpenKey ? [latestOpenKey] : []
        }
    }
    handleSelected(e: any) {
        this.selectedKeys = e.selectedKeys
    }

    resolvePath(route: RouteConfig) {
        const routesChildrenShow = route.children?.filter((r: any) => !r.hidden) ?? []
        if (routesChildrenShow.length == 1) {
            return (route.redirect as string) || route.path
        }
        return route.path
    }
    mounted() {
        this.updateMenu()
    }
}
